import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'

const MESSAGE_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
}

/**
 * A mapping of message type to color.
 * @type {Object}
 */
const MESSAGE_TYPE_TO_COLOR = {
  [MESSAGE_TYPE.SUCCESS]: STYLES_COLOR.BLACK,
  [MESSAGE_TYPE.WARNING]: STYLES_COLOR.ORANGE,
  [MESSAGE_TYPE.ERROR]: STYLES_COLOR.RED
}

export {
  MESSAGE_TYPE,
  MESSAGE_TYPE_TO_COLOR
}
